<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Banka"
            label-for="banks"
          >
            <v-select
              id="banks"
              v-model="posConfig.id_banks"
              :options="banks"
              label="title"
              :reduce="bank => bank.id"
              placeholder="Seçiniz"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Sanal Pos"
            label-for="pos_types"
          >
            <v-select
              id="pos_types"
              v-model="posConfig.id_pos_types"
              :options="posTypes"
              label="title"
              :reduce="posType => posType.id"
              placeholder="Seçiniz"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
        >
          <b-form-group
            label="Varsayılan Banka"
            label-for="default"
          >
            <b-form-checkbox
              id="default"
              v-model="posConfig.default"
              name="check-button"
              switch
              inline
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
        >
          <b-form-group
            label="Durum"
            label-for="status"
          >
            <b-form-checkbox
              id="status"
              v-model="posConfig.status"
              name="check-button"
              switch
              inline
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
        >
          <b-form-group
            label="3D Ödeme"
            label-for="pay3d"
          >
            <b-form-checkbox
              id="pay3d"
              v-model="posConfig.pay3d"
              name="check-button"
              switch
              inline
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <nestpay v-if="posConfig.id_pos_types === '1'" />
    <gvp v-if="posConfig.id_pos_types === '2'" />
    <get724 v-if="posConfig.id_pos_types === '3'" />
    <posnet v-if="posConfig.id_pos_types === '4'" />
    <payfor v-if="posConfig.id_pos_types === '5'" />
    <akbank-config v-if="posConfig.id_pos_types === '6'" />
  </div>
</template>
<script>
import {
  BCard, BCol, BFormCheckbox, BFormGroup, BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Get724 from '@/views/PosConfigs/Configs/Get724.vue'
import Gvp from '@/views/PosConfigs/Configs/Gvp.vue'
import Posnet from '@/views/PosConfigs/Configs/Posnet.vue'
import Payfor from '@/views/PosConfigs/Configs/Payfor.vue'
import Nestpay from '@/views/PosConfigs/Configs/Nestpay.vue'
import AkbankConfig from '@/views/PosConfigs/Configs/AkbankConfig.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BFormCheckbox,
    BFormGroup,
    BCol,
    BRow,
    vSelect,
    Nestpay,
    Payfor,
    Posnet,
    Gvp,
    Get724,
    AkbankConfig,
  },
  computed: {
    banks() {
      return this.$store.getters['banks/getBanks']
    },
    posTypes() {
      return this.$store.getters['posConfigs/getPosTypes']
    },
    posConfig() {
      return this.$store.getters['posConfigs/getPos_config']
    },
  },
  created() {
    this.getBanks()
    this.getPosTypes()
  },
  methods: {
    getBanks() {
      this.$store.dispatch('banks/banks')
    },
    getPosTypes() {
      this.$store.dispatch('posConfigs/pos_types')
    },
  },
}
</script>
